exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.line[data-v-a1c11f16] {\n  text-align: center;\n}\n", ""]);

// exports
